/* eslint-disable no-void */
import GLOBAL from './GLOBAL';

let executeImmediately = false;

const addLoadEventHandler = (fn) => {
  const win = GLOBAL.getWindow();
  if (executeImmediately) {
    win.setTimeout(() => fn(), 0);
  } else if (win.addEventListener) {
    win.addEventListener('load', fn, false);
  } else if (win.attachEvent) {
    win.attachEvent('onload', fn);
  } else {
    void 0;
  }
};
addLoadEventHandler(() => {
  executeImmediately = true;
});

export default addLoadEventHandler;
